/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import moment from 'moment';
import resizeImage from '/client/src/utils/resizeImage';
import HoverSplash from './hoverSplash';
import Loader from '/client/src/components/Loader';


type PropsType = {
  p: {
    events?: [],
    link_label: string,
    id: number
  }
};

type SingleEventPropsType = {
  eventId?: string | number,
  requestUrl?: string,
  upData?: () => void,
  event?: any
};

export const SingleEventRef = React.createRef();

export const SingleEvent = ({ event, eventId, requestUrl, upData, placementIndex }: SingleEventPropsType): React.Element => {
  const [data, setData] = React.useState(event || null);

  const handleLoaded = React.useCallback(
    async (error: Error, response: any) => {
      if (!error) {
        try {
          const _data = response.data.result;
          const setedData = _data && _data[0] ? _data[0] : _data;

          setData(setedData);

          if (upData) {
            upData(setedData);
          }
        } catch (e) {
          console.error('cant get events list');
        }
      }
    },
    []
  );

  return (
      event ?
      <div className="col-xs-12 col-sm-6 col-lg-4">
        <a>
          <div
            className="sparxo-event sparxo-event-card"
            id='othereventlist'
            data-event-id={data ? data.id : ''}
            ref={SingleEventRef}
          >
            <div className="sparxo-event-image-warper">
              <div
                className="sparxo-event-image"
                style={{
                  backgroundImage: `url('${(() => { // eslint-disable-line
                    if (data) {
                      return data.image_url;
                    }

                    return null;
                  })(data)}')`
                }}
              />
            </div>

            <div className="sparxo-event-info">
              <div className="sparxo-evnet-info-left">
                <div className="month">
                  {data ? moment(data.begin_time_utc).format('MMM') : ''}
                </div>
                <div className="day">
                  {data ? moment(data.begin_time_utc).format('DD') : ''}
                </div>
              </div>

              <div className="sparxo-event-info-right">
                <div className="name">{data ? data.name : ''}</div>
                <div className="time">
                  <i className="icon icon-clock-o" style={{ marginRight: '3px' }} />
                  <span>{data ? moment(data.begin_time_utc).format('MMM DD h:mm a') : ''}</span>
                </div>
                <div className="addr">
                  <i className="icon icon-location" />
                  <span>{data ? data.location : ''}</span>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    :
    <Loader
      url={!requestUrl ? `/api/v1/1/events/summary?ids=${eventId}` : requestUrl}
      onLoaded={handleLoaded}
      // useNProgress
    >
      <div className="col-xs-12 col-sm-6 col-lg-4">
        <a>
          <div
            className="sparxo-event sparxo-event-card"
            id='othereventlist'
            data-event-id={data ? data.id : ''}
            ref={SingleEventRef}
            data-event-placement={placementIndex}
          >
            <div className="sparxo-event-image-warper">
              <div
                className="sparxo-event-image"
                style={{
                  backgroundImage: `url('${(() => { // eslint-disable-line
                    if (data) {
                      return data.image_url;
                    }

                    return null;
                  })(data)}')`
                }}
              />
            </div>

            <div className="sparxo-event-info">
              <div className="sparxo-evnet-info-left">
                <div className="month">
                  {data ? moment(data.begin_time_utc).format('MMM') : ''}
                </div>
                <div className="day">
                  {data ? moment(data.begin_time_utc).format('DD') : ''}
                </div>
              </div>

              <div className="sparxo-event-info-right">
                <div className="name">{data ? data.name : ''}</div>
                <div className="time">
                  <i className="icon icon-clock-o" style={{ marginRight: '3px' }} />
                  <span>{data ? moment(data.begin_time_utc).format('MMM DD h:mm a') : ''}</span>
                </div>
                <div className="addr">
                  <i className="icon icon-location" />
                  <span>{data ? data.location : ''}</span>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </Loader>
  );
};

const Event = (props: PropsType): React.Element<'div'> => {
  const { p } = props;
  const [load, setLoad] = React.useState(false);

  React.useEffect(() => {
    setLoad(true);
    setTimeout((): void => setLoad(false), 0);
  }, [p]);

  return (
    <div className={`splash-section ${p.background_color === 'Light' ? 'splash_section_light' : 'splash_section_dark'}`} id={`${_.toLower(p.link_label)}${p.id}`}>
      <div className="splash-container">
        {!load ?
          <div className="row">
            {_.map(_.sortBy(p.events, (_p: {}): number => _p.placement_index), (ev: {}, evi: number): React.Elemnt<'div'> => {
              return (
                <SingleEvent
                  placementIndex={ev.placement_index}
                  eventId={ev.event_id.toString()}
                  key={`Event-${evi}`}
                />
              );
            })}
          </div>
          :
          <div style={{ position: 'relative', margin: '20px auto', textAlign: 'center', background: 'red' }}>
            <span className='csspinner' />
          </div>
        }
      </div>

      <HoverSplash {...props} />
    </div>
  );
};

export default Event;
